module.exports = __webpack_public_path__ + "static/img/home-page-added.58a8fc83.svg";